<template>
  <div class="form">
    <van-nav-bar title="项目详情" />
    <div style="margin-top: 1rem" v-if="acceptFormId">
      <van-collapse v-model="activeName" accordion>
        <van-collapse-item title="基本信息" name="1">
          <van-cell-group>
            <van-cell title="项目名称" :value="formData.projectName" />
            <van-cell title="建设单位" :value="formData.applyOrgName" />
            <van-cell title="项目联系人" :value="formData.contactPerson" />
            <van-cell title="项目联系电话" :value="formData.contactNumber" />
            <van-cell title="项目地址" :value="formData.address" />
            <van-cell
              v-if="formData.isRelevanced"
              title="工程类别"
              :value="formData.projectCategory"
            />
            <template v-if="formData.isRelevanced">
              <van-cell
                v-if="formData.architecturalInNature"
                title="使用性质"
                :value="formData.architecturalInNature"
              />
              <van-cell
                v-else
                title="使用性质"
                :value="formData.architecturalInNature"
              />
            </template>

            <van-cell title="状态" :value="formData.acceptStatusResult" />
            <van-cell title="计划开始日期">
              <span style="vertical-align: middle">{{
                formData.acceptTime | time('yyyy-MM-dd HH:mm')
              }}</span>
            </van-cell>
            <van-cell title="计划结束日期">
              <span style="vertical-align: middle">{{
                formData.acceptEndTime | time('yyyy-MM-dd HH:mm')
              }}</span>
            </van-cell>
          </van-cell-group>
        </van-collapse-item>
        <van-collapse-item title="现场签到列表" name="2">
          <van-cell-group
            v-for="users in formData.acceptEmployeeDTOs"
            :key="users.userCode"
          >
            <template v-if="users.signTime" #title>
              <span style="color: #333">{{ users.userName }}</span>
              <div>
                <span>签到时间：</span>
                <van-icon style="vertical-align: middle" name="clock-o" />
                <span style="vertical-align: middle">{{ users.signTime }}</span>
              </div>
            </template>
            <template v-else>未签到</template>
          </van-cell-group>
          <div v-if="!formData.acceptEmployeeDTOs">暂无数据</div>
        </van-collapse-item>
        <van-collapse-item title="相关验收记录" name="3">
          <van-collapse accordion v-model="activeName2">
            <div v-for="item in acceptTypes" :key="item.acceptProjectId">
              <van-collapse-item
                :title="item.acceptProjectName"
                :name="item.acceptProjectId"
              >
                <van-collapse accordion v-model="activeName3">
                  <div
                    v-for="(item2, i) in item.acceptProjectTypeDetailList"
                    :key="i"
                  >
                    <van-collapse-item :name="'C_' + i">
                      <template #title>
                        <span style="color: #017eff">{{
                          item2.acceptProjectTypeName
                        }}</span
                        ><span style="color: #999; font-size: 12px"
                          >（{{ item2.acceptContent }}）</span
                        >
                      </template>
                      <van-cell-group>
                        <van-cell title="要求" :value="item2.acceptRequire" />
                        <van-cell title="重要程度">
                          <van-tag type="primary"
                            >{{ item2.important }}
                          </van-tag>
                        </van-cell>
                        <van-cell title="状态" :value="item2.statusStr" />
                        <van-cell
                          title="检查情况"
                          :value="item2.auditAcceptContent"
                        />
                        <van-cell
                          title="检查数量"
                          :value="item2.acceptNumber"
                        />
                      </van-cell-group>
                    </van-collapse-item>
                  </div>
                  <div v-if="!item.acceptProjectTypeDetailList">暂无数据</div>
                </van-collapse>
              </van-collapse-item>
            </div>
          </van-collapse>
        </van-collapse-item>
        <van-collapse-item title="主责承办人评定意见" name="4">
          <van-cell-group>
            <van-cell title="评定结果">
              <van-tag
                v-if="formData.opinionStatus === 3"
                type="danger"
                size="medium"
                >不合格</van-tag
              >
              <van-tag
                v-if="formData.opinionStatus === 4"
                type="success"
                size="medium"
                >合格</van-tag
              >
            </van-cell>
            <van-cell
              title="评定时间"
              :value="formData.mainUndertakeOpinionTime"
            />
            <van-cell title="评定意见" :value="formData.mainUndertakeOpinion" />
          </van-cell-group>
        </van-collapse-item>
        <van-collapse-item title="技术复核人评定意见" name="5">
          <van-cell-group>
            <van-cell title="评定时间" :value="formData.technicalOpinionTime" />
            <van-cell title="评定意见" :value="formData.technicalOpinion" />
          </van-cell-group>
        </van-collapse-item>
      </van-collapse>

      <div style="margin: 1rem">
        <van-button
          round
          block
          type="info"
          native-type="button"
          @click="go2sign"
        >
          前往签名
        </van-button>
      </div>
    </div>

    <div v-if="!acceptFormId" class="noData">
      <van-empty image="error" description="暂无数据，请确保您已正确打开网站" />
    </div>
  </div>
</template>

<script>
import { groupBy } from 'lodash-es'
import {
  NavBar,
  Collapse,
  CollapseItem,
  Cell,
  CellGroup,
  Button,
  Tag,
  Icon,
  Empty,
  Toast,
} from 'vant'
import { http } from '../lib/http'
import axios from 'axios'

export default {
  components: {
    'van-nav-bar': NavBar,
    'van-collapse': Collapse,
    'van-collapse-item': CollapseItem,
    'van-cell': Cell,
    'van-cell-group': CellGroup,
    'van-button': Button,
    'van-tag': Tag,
    'van-icon': Icon,
    'van-empty': Empty,
  },

  data() {
    return {
      formData: {},
      activeName: ['1'],
      activeName2: [],
      activeName3: [],
      secret: null,
      employees: {},
      applyFormId: null,
      acceptFormId: null,
      acceptTypes: null,
      projectCategory: {
        0: '新建',
        1: '扩建',
        3001: '装饰装修',
        3002: '建筑保温',
        3003: '改变用途',
      },
    }
  },
  created() {
    const { params } = this.$route.query
    if (params) {
      let { applyFormId, acceptFormId } = JSON.parse(this.decode(params))
      this.applyFormId = applyFormId
      this.acceptFormId = acceptFormId
      this.getData()
      this.getChildData()
    }
  },

  methods: {
    getData() {
      try {
        http
          .get(
            `api/Fire/Accept/GetAcceptFormInfo?applyFormId=${this.applyFormId}&acceptFormId=${this.acceptFormId}`
          )
          .then((res) => {
            res.data.projectCategory =
              res.data.projectCategory
                ?.split(',')
                ?.map((cate) => this.projectCategory[cate])
                ?.join(',') || ''
            console.log(res)
            for (var key in res.data) {
              this.$set(this.formData, key, res.data[key])
            }
          })
          .catch((err) => {
            console.log(err)
            Toast.fail(err.message || '请求失败')
          })
      } catch (e) {
        Toast(e)
      }
    },
    getChildData() {
      http
        .get(
          `api/Fire/Accept/GetAcceptFormProjectAuditData?acceptFormId=${this.acceptFormId}`
        )
        .then((res) => {
          this.acceptTypes = res.data.acceptProjectTypes
        })
        .catch((err) => {
          Toast.fail(err.message || '请求失败')
        })
    },
    go2sign() {
      this.$router.push({
        path: `/signature?formData=${encodeURIComponent(
          JSON.stringify(this.formData)
        )}`,
      })
    },
    //解密
    decode(str) {
      return decodeURIComponent(
        atob(str)
          .split('')
          .map(function (c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
          })
          .join('')
      )
    },
  },
  computed: {
    data() {
      return JSON.stringify(this.formData)
    },
  },
}
</script>
<style lang="less" scoped>
.title {
  width: 10ex;
  margin: 1ex auto;
}

.red {
  color: red;
}

.blue {
  color: blue;
}

.green {
  color: green;
}

.form {
  font-size: 18px;
}

.noData {
  flex: 1;
  justify-content: center;
  align-items: center;
  display: flex;
}

.form {
  display: flex;
  flex-direction: column;
  min-height: 100vh;

  /deep/ .van-collapse-item__header {
    padding: 0 10px;
  }

  /deep/ .van-collapse-item__content {
    padding: 0 10px;
  }
}
</style>
